import React from 'react'


function ProductListShimmer() {


  return (
  <div className="col-md-4 col-sm-4 col-xs-12 mb-40 shimmer-product-list">
    <div className="productlist">
      <div className="imgbox"></div>
      <div className="producttitle">
        <h2></h2>
        <div className="price"></div>
      </div>
    </div>
  </div>
  )
}

export default ProductListShimmer
